export enum DeliveryPreferences {
  pickup = 'PICKUP',
  ship = 'SHIP',
}
const enumerations = {
  DeliveryPreferences,
}

export enum deliveryTypes {
  pickup = 'PICKUP',
  ship = 'SHIP',
}

export enum appTypes {
  FORT_SYSTEM = 'FORT_SYSTEM',
  WINE_SHIPPING = 'WINE_SHIPPING',
}

export default enumerations
